import {createModelSchema, list, alias} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {MultiTabStageModel} from "@/modules/redactor/models/smart-offer/bundle-multi-tab/MultiTabStageModel";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";


export class SmartOfferBundleMultiTab extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.MULTI_TAB);

        this._stages = [];
        this._rewardTrack = null;
    }

    get stages() {
        return this._stages;
    }

    set stages(value) {
        this._stages = value;
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    valid() {

        if (!this.stages || this.stages.length === 0) {
            return false;
        }

        if (this.stages.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.rewardTrack && !this.rewardTrack.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.stages || this.stages.length === 0) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleMultiTab());
        } else if (target instanceof SmartOfferBundleMultiTab) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleMultiTab, {
    _stages: alias("stages", list(MultiTabStageModel.schema())),
    _rewardTrack: alias("reward_track", RewardTrack.schema())
});
